import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/common/axios'

Vue.use(Vuex)

const general = {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    getters: {
    },
    actions: {
        async createEntry ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                let result = await axios.post('/entry', data)
                return result
            } catch (error) {
                throw new Error(error.response.data.message)
            }
        }
    }
}

export default general



// WEBPACK FOOTER //
// ./src/store/general.js